import React, { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { isMobile } from "react-device-detect";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";
import { getAllMentorReports } from "../../services/report.service";

function Report(props) {
  const navigate = useNavigate();

  const [data, setData] = useState(false);
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    async function api() {
      try {
        setProgress(true);
        const filters = {
          type: "Mentor",
        };

        const data = await getAllMentorReports(filters);

        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed]);

  function CustomRow(props) {
    const { row, index, skipValue } = props;

    return (
      <>
        <TableRow key={row._id}>
          <TableCell>{index + 1 + skipValue}</TableCell>
          <TableCell>
            <Link
              to={"/dashboard/courses/edit/" + row.course._id}
              className="hover:underline"
            >
              {row.course.name}
            </Link>
          </TableCell>

          <TableCell>
            <Link
              to={"/dashboard/mentors/" + row.mentor._id}
              className="hover:underline"
            >
              {row.mentor.firstname + " " + row.mentor.lastname}
            </Link>
          </TableCell>
          <TableCell>{row.session?.sessionNumber ?? "-"}</TableCell>
          <TableCell>
            {row.session
              ? moment(row.session?.time).format("h:mm a") +
                "-" +
                moment(row.session?.endTime).format("h:mm a") +
                " " +
                moment(row.session?.time).format("DD/MM/YYYY")
              : "-"}
          </TableCell>
          <TableCell>
            {(row.agoraRecordingStatus === "RECORDED").toString()}
          </TableCell>
          <TableCell>{row.message}</TableCell>
          <TableCell>
            {moment(row.createdAt).format("dddd, MMMM Do YYYY, h:mm a")}
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <div>
      <Box style={{ width: "100%" }}>
        <TableContainer>
          <div className="flex justify-end gap-5">
            {/* <Button
              variant="outlined"
              className="my-8"
              onClick={(e) => {
                navigate("/dashboard/mentor/edit");
              }}
            >
              Create Payroll
            </Button> */}
          </div>
          <Table size="small">
            <TableHead className="">
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Course</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Mentor</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Session Number
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Session Time
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Recording Available
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Reason</TableCell>

                <TableCell style={{ fontWeight: "bold" }}>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                ? data.map((row, index) => {
                    return (
                      <CustomRow
                        row={row}
                        key={index}
                        index={index}
                        skipValue={0}
                      />
                    );
                  })
                : null}
            </TableBody>
          </Table>
          {/* <div style={{ marginTop: '20px', textAlign: 'center' }} hidden={survey.length != 0}>
                No data with given filters
            </div> */}
        </TableContainer>
      </Box>
    </div>
  );
}

export default Report;
